/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.x.ai.integration.rpc.AppSettingsRpc
 */

export const installRpc = {
  serviceName: 'com.hubspot.x.ai.integration.rpc.AppSettingsRpc',
  rpcName: 'install',
  auth: 'app',
  fingerprint: 'zAyifeVsX_SOLisWpuNhsX7dq3pjbAQ3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertApiKeyRpc = {
  serviceName: 'com.hubspot.x.ai.integration.rpc.AppSettingsRpc',
  rpcName: 'upsertApiKey',
  auth: 'app',
  fingerprint: '5bBMaH2A99Qs9ON1fOU11X7dq3pjbAQ3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};